import {
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from "@mui/material";
import { TypographyComponent } from "../typography/typography.component";
import classnames from "classnames";
import styles from "./toggle-switch.styles.module.scss";

  type ToggleSwitchProps = {
    theme?: "light" | "dark";
    size?: "regular" | "small"
    ariaLabel?: string;
    label?: string;
    helperText?: string;
    isChecked?: boolean;
    isDisabled?: boolean;
    onChange?: MuiSwitchProps["onChange"];
    additionalProps?: Partial<MuiFormControlLabelProps>;
    additionalControlProps?: Partial<MuiSwitchProps>;
    rootClassName?: string;
  };

export const ToggleSwitchComponent = ({
  theme = "light",
  size = "regular",
  ariaLabel,
  label,
  helperText,
  isChecked = false,
  isDisabled = false,
  onChange = () => {},
  additionalProps = {},
  additionalControlProps = {},
  rootClassName,
}: ToggleSwitchProps) => (
  <MuiFormControlLabel
    {...additionalProps}
    disabled={isDisabled}
    label={
      <div className={classnames(styles.labelContent, rootClassName)}>
        {
          {
            "regular": <>
              <TypographyComponent styling={"metadata-lg"}>{label}</TypographyComponent>
              <TypographyComponent styling={"metadata-default"}>{helperText}</TypographyComponent>
            </>,
            "small": <>
              <TypographyComponent styling={"metadata-default"}>{label}</TypographyComponent>
              <TypographyComponent styling={"metadata-sm"}>{helperText}</TypographyComponent>
            </>
          }[size]
        }
      </div>
    }
    classes={{
      root: classnames(
        styles.formControl,
        styles.formControlRoot,
        {
          [styles.sizeRegular]: size === "regular",
          [styles.sizeSmall]: size === "small",
        }
      ),
      label: classnames(
        styles.label,
        {
          [styles.themeLight]: theme === "light",
          [styles.themeDark]: theme === "dark",
        }
      ),
      disabled: styles.disabled,
    }}
    control={
      <MuiSwitch
        {...additionalControlProps}
        aria-label={ariaLabel}
        disableFocusRipple={true}
        disableRipple={true}
        onChange={onChange}
        disabled={isDisabled}
        checked={isChecked}
        classes={{
          root: classnames(
            styles.switchRoot,
            {
              [styles.themeLight]: theme === "light",
              [styles.themeDark]: theme === "dark",
              [styles.sizeRegular]: size === "regular",
              [styles.sizeSmall]: size === "small",
            }
          ),
          switchBase: styles.switchBase,
          track: styles.track,
          thumb: styles.thumb,
          checked: styles.checked,
          disabled: styles.disabled,
        }}
      />
    }
  />
);
